/**
 * The manual's one kind of link to its own pages, shared by the header, the
 * rail, the sheet, the contents page and the pager.
 */
import type React from 'react';
import { hrefFor } from '../lib/router';

/** A link that routes in-page but is a real `href` a crawler and ⌘-click can use. */
export function Link({
  id,
  onGo,
  children,
  className,
  current
}: {
  id: string;
  onGo: (id: string) => void;
  children: React.ReactNode;
  className?: string;
  current?: boolean;
}): React.JSX.Element {
  return (
    <a
      href={hrefFor(id)}
      className={className}
      aria-current={current ? 'page' : undefined}
      onClick={(event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
        event.preventDefault();
        onGo(id);
      }}
    >
      {children}
    </a>
  );
}

/** A chapter number as the lists print it: two digits. */
export const pad = (n: number): string => String(n).padStart(2, '0');
